// css
import '../../scss/pages/page-takepen.scss';

// utils
import foundation from '../_utils/foundation';
foundation();

document.addEventListener('DOMContentLoaded', () => {});

window.addEventListener('load', () => {});